import ReactGA from 'react-ga4'

function generateGoogleCalendarURL(event) {
    const startDate = event.startDate.toISOString().replace(/-|:|\.\d+/g, '')
    const endDate = event.endDate.toISOString().replace(/-|:|\.\d+/g, '')
    const url = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
        event.title
    )}&dates=${startDate}/${endDate}&details=${encodeURIComponent(event.description)}&location=${encodeURIComponent(
        event.location
    )}`
    return url
}

function AddToCalendarButton({ event }) {
    const googleCalendarURL = generateGoogleCalendarURL(event)
    const handleGoogleCalendarClick = () => {
        window.open(googleCalendarURL, '_blank')
        ReactGA.event({
            action: 'click',
            event: 'link',
            category: 'Calendar',
            label: `Google Calendar`,
        })
    }
    return (
        <div>
            <button
                className='min-w-[300px] md:min-w-none font-sans font-bold hover:brightness-125 hover:scale-105 duration-200 bg-red-700 text-white border-double border-4 border-white inline-block py-4 text-center px-4 md:px-20 shadow-md '
                onClick={handleGoogleCalendarClick}
            >
                Add to Google Calendar
            </button>
        </div>
    )
}

export default AddToCalendarButton
